
// Filter

const filterMenu = document.querySelector('.filter');
const filterItems = document.querySelectorAll('.filter__item');
const filterList = document.querySelector('.filter__items');
const filterOpenBtn = document.querySelector('.filter__button--main');
const submitBtn = document.querySelector('.filter__submitButton');
const radios = document.querySelectorAll('.filter__radio');
const loadMoreBtn  = document.querySelector('.loadMore__button');
const productList = document.querySelector('.productList');
const collections = document.querySelector('.productList__collection');

let appliedFilter = [];
let setFilter = [];
let page = productList ? parseInt(productList.dataset.page) : null;
let filterArgsString = '';
let productAmount = productList ? parseInt(productList.dataset.amount) : null;

if(filterMenu){
    filterOpenBtn.addEventListener('click', (event) => {
        if(filterMenu.dataset.open == 'true'){
            event.target.setAttribute('aria-expanded', 'false');
            filterMenu.dataset.open = 'false';
        } else {
            event.target.setAttribute('aria-expanded', 'true');
            filterMenu.dataset.open = 'true';
        }
    });

    filterItems.forEach((filterItem) => {
        const list = filterItem.querySelector('.filter__list');
        const removeBtn = filterItem.querySelector('.filter__removeButton');
        const filterRadios = filterItem.querySelectorAll('.filter__radio');

        filterItem.addEventListener('click', (event) => {

            // open dropdown
            if(event.target.matches('.filter__button')){            
                filterItems.forEach((item) => {
                    if(item !== filterItem){
                        item.dataset.open = 'false';
                        item.querySelector('.filter__button').setAttribute('aria-expanded', 'false');
                    }
                });
                if(filterItem.dataset.open == 'true'){
                    event.target.setAttribute('aria-expanded', 'false');
                    filterItem.dataset.open = 'false';
                } else {
                    event.target.setAttribute('aria-expanded', 'true');
                    filterItem.dataset.open = 'true';
                    filterItem.querySelector('.filter__list').scrollTop = 0;

                }
            }

            // set filter
            if(event.target.matches('.filter__option')){
                
            }

            // remove filter
            if(event.target.matches('.filter__removeButton')){
                filterRadios.forEach((radio) => {
                    radio.checked = false;
                });
                filterItem.dataset.chosen = 'false';
                filterItem.dataset.open = 'false';
                event.target.previousElementSibling.setAttribute('aria-expanded', 'false');
                event.target.previousElementSibling.querySelector('.filter__choice').innerText = '';
                updateFilter();
            }
            
        });
    })
    radios.forEach((radio) => {
        radio.addEventListener('change', (event) =>{
                   
            // set choice
            const filterItem = event.target.parentNode.parentNode.parentNode;
            const label = event.target.parentNode.dataset.value;
            const filterButton = filterItem.querySelector('.filter__button');
            const checkedRadios = [...radios].filter((radio) => radio.checked);

            filterItem.dataset.chosen = 'true';
            filterButton.setAttribute('aria-expanded', 'false');
            filterButton.querySelector('.filter__choice').innerText = label;

            filterMenu.dataset.chosen = 'true';
            filterMenu.setAttribute('filter-to-apply', 'true');
            updateFilter()
            
            
            //close dropdown
            filterItems.forEach((item) => {
                item.dataset.open = 'false';
                item.querySelector('.filter__button').setAttribute('aria-expanded', 'false');
            });
        });
    })
    
    submitBtn.addEventListener('click', (event) => {
        filterOpenBtn.setAttribute('aria-expanded', 'false');
        filterMenu.dataset.open = 'false';
        filterMenu.removeAttribute('filter-to-apply');
        appliedFilter = setFilter;
        updateProjects(setFilter);
        
    });


    loadMoreBtn.addEventListener('click', () => {
        fetchProjects(filterArgsString);
        page++
    });

}

function updateFilter(){
        setFilter = [];
        const radios = document.querySelectorAll('.filter__radio');
        radios.forEach((radio) => {
            if(radio.checked){
                setFilter.push(
                    {
                        filterType: radio.name,
                        filterValue: radio.dataset.value
                    }
                );
            }
        });
        filterOpenBtn.querySelector('.filter__amount').innerText = setFilter.length;
        if(setFilter.length < 1){
            filterMenu.dataset.chosen = 'false';
        }
        //console.log(JSON.stringify(setFilter), JSON.stringify(appliedFilter), JSON.stringify(setFilter) == JSON.stringify(appliedFilter))
        if(JSON.stringify(setFilter) == JSON.stringify(appliedFilter)){
            filterMenu.removeAttribute('filter-to-apply');
        } else {
            filterMenu.setAttribute('filter-to-apply', 'true');
        }
        filterArgsString = '';
        if(setFilter.length > 0){
            const filterArgs = [];
        
            setFilter.forEach((filter) => {
                filterArgs.push(`${filter.filterType}=${filter.filterValue}`);
            });
            filterArgsString = '?' + filterArgs.join('&');
        }
        fetchFilters(filterArgsString);
    }


function compareFilter(currentFilter, newFilter){
    filterOpenBtn.querySelector('.filter__amount').innerText = checkedRadios.length + 1;

}

function updateProjects(){
    productList.innerHTML = '';
    productAmount = 0;
    page = 1;

    filterArgsString = '';
    if(setFilter.length > 0){
        const filterArgs = [];
       
        setFilter.forEach((filter) => {
            filterArgs.push(`${filter.filterType}=${filter.filterValue}`);
        });
        filterArgsString = '?' + filterArgs.join('&');
    }
    fetchProjects(filterArgsString);
}


async function fetchProjects(filterArgsString = ''){
    let url = `${window.location.href.split('#')[0]}.json/page:${page}${filterArgsString}`;
    try {
        const response = await fetch(url);
        const { html, more, amount, filters} = await response.json();
        loadMoreBtn.hidden = !more;
        productList.insertAdjacentHTML('beforeend', html);
        productAmount += amount;
        renderPlaceholders(productAmount);

    } catch (error) {
        console.log('Fetch error: ', error);
    }
}

async function fetchFilters(filterArgsString = ''){
    let url = `${window.location.href.split('#')[0]}.json/${filterArgsString}`;
    try {
        const response = await fetch(url);
        const {filters} = await response.json();
        updateFilterOptions(filters);

    } catch (error) {
        console.log('Fetch error: ', error);
    }
}


function renderPlaceholders(amount){
    const placeholders = document.querySelectorAll('.placeholder-form');
    placeholders.forEach(placeholder => placeholder.remove())
    for(let i = 1; i < 5; i++){
        const h5 = (5 - amount % 5 >= i) && (amount % 5 > 0) ? 'block' : 'none'; 
        const h4 = (4 - amount % 4 >= i) && (amount % 4 > 0) ? 'block' : 'none'; 
        const h3 = (3 - amount % 3 >= i) && (amount % 3 > 0) ? 'block' : 'none'; 
        const h2 = (2 - amount % 2 >= i) && (amount % 2 > 0) ? 'block' : 'none';
        productList.innerHTML += `
            <img class="placeholder-form" src="../../assets/images/form/${i+2}f.svg" style="--ph5: ${h5}; --ph4: ${h4}; --ph3: ${h3}; --ph2: ${h2}; ">
        `;
    }
}

function updateFilterOptions(filtersOptions){
    filterItems.forEach((filterItem) => {
        const currentFilterOptions = filtersOptions[filterItem.id].data
        const currentRadios = filterItem.querySelectorAll('.filter__radio');
        currentRadios.forEach((radio) => {
            radio.removeAttribute('disabled')
            if(!currentFilterOptions.includes(radio.dataset.value)){
                radio.disabled = true;
            }
        })
    })
}